/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ContactInputs */

const en_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const ar_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل`)
};

const bn_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যোগাযোগ`)
};

const de_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const es_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const fr_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const pt_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato`)
};

const zh_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系方式`)
};

const tr_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const ru_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакт`)
};

const pl_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Nav_ContactInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_contact = /** @type {((inputs?: Nav_ContactInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ContactInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_contact(inputs)
	if (locale === "bn") return bn_nav_contact(inputs)
	if (locale === "de") return de_nav_contact(inputs)
	if (locale === "es") return es_nav_contact(inputs)
	if (locale === "fr") return fr_nav_contact(inputs)
	if (locale === "pt") return pt_nav_contact(inputs)
	if (locale === "zh") return zh_nav_contact(inputs)
	if (locale === "tr") return tr_nav_contact(inputs)
	if (locale === "ru") return ru_nav_contact(inputs)
	if (locale === "pl") return pl_nav_contact(inputs)
	return en_nav_contact(inputs)
});